module.exports = __webpack_public_path__ + "static/media/physician02.2bcd350d.jpeg";